import React from 'react';
import { Box, Typography } from '@mui/material';
import NewMfrSeedForm from '../components/NewMfrSeedForm';

const NewMfrSeedPage: React.FC = () => {
  const handleSuccess = () => {
    console.log('Seed created successfully');
    window.location.href = '/admin/manufacturer_management?activeTab=2';
  };

  return (
    <Box p={2}>
      <NewMfrSeedForm onSuccess={handleSuccess} />
    </Box>
  );
};

export default NewMfrSeedPage;
